import {
  scrollParcelleToTop,
  selectParcelle,
  Status,
} from 'redux/features/parcelle/slice'
import {
  makeSelectParcelles,
  makeSelectSelectedParcelleIndex,
  makeSelectStatusParcelle,
} from 'redux/features/parcelle/selectors'

import { useAppDispatch, useAppSelector } from 'redux/hooks'
import Parcelle from 'entity/Parcelle'
import { calculBounds } from 'utils/calculBounds'
import PolygonMarker from 'components/PolygonMarker'
import useGoogleMap from 'hooks/useGoogleMap'
import useTrackRecherche from 'hooks/useTrackRecherche'
import { checkParcelleVue } from 'utils/parcellesVues'
import useFiltreBienAVendre from 'hooks/useFiltreBienAVendre'
import geoJsonObjectToCoordinates from 'utils/geoJsonObjectToCoordinates'

const ResultsParcelle = (): JSX.Element | null => {
  const parcelles = useAppSelector(makeSelectParcelles)
  const selectedParcelleIndex = useAppSelector(makeSelectSelectedParcelleIndex)
  const statusParcelle = useAppSelector(makeSelectStatusParcelle)
  const map = useGoogleMap()
  const dispatch = useAppDispatch()

  const selectResult = (selectedParcelle: Parcelle) => {
    const bounds = calculBounds(
      geoJsonObjectToCoordinates(selectedParcelle.geographie)
    )
    map?.fitBounds(bounds)
    map?.panToBounds(bounds)
    dispatch(selectParcelle(selectedParcelle.uid))
    dispatch(scrollParcelleToTop())
  }

  const { estRetireParLeFiltrage } = useFiltreBienAVendre()

  useTrackRecherche({ status: statusParcelle, event: 'rechercheBiensAVendre' })

  return (
    (statusParcelle === Status.ShowParcelleResults && (
      <>
        {parcelles.map((parcelle, ix) => {
          const { centre, geographie, uid } = parcelle

          if (estRetireParLeFiltrage(parcelle.uid)) {
            return null
          }

          const centerMarker = {
            lat: centre.latitude,
            lng: centre.longitude,
          }

          const coordGlobal = geoJsonObjectToCoordinates(geographie).map(
            (coord) => ({
              lat: coord[1],
              lng: coord[0],
            })
          )

          return (
            <PolygonMarker
              key={uid}
              center={centerMarker}
              coordGlobal={coordGlobal}
              isSelected={ix === selectedParcelleIndex}
              isMarkedAsSeen={checkParcelleVue(uid)}
              onClick={() => selectResult(parcelle)}
            />
          )
        })}
      </>
    )) ||
    null
  )
}

export default ResultsParcelle
